import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	Grid,
	// FormHelperText,
	// Paper,
	withStyles,
	Typography,
} from '@material-ui/core'
import ReactSelect from 'components/theme/Select'
import { groupOptionsSelector, contactOptionsSelector } from 'selectors'
import language from 'utils/vast-languagepack'
import {
	selectGroup,
	selectGroupToAddTo,
	selectGroupToRemoveFrom,
	selectContactsForGroup,
} from 'actions/tasks'
import GroupDialog from 'components/GroupDialog'
import { toggleGroupDialog } from 'actions/contacts/groups'

export default connect(
	(state) => ({
		selectedAction: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
		groupOptions: groupOptionsSelector(state),
		contactOptions: contactOptionsSelector(state),
		groupSelected: state.tasks.addOrEdit.groupSelected,
		groupToAddToSelected: state.tasks.addOrEdit.groupToAddToSelected,
		groupToRemoveFromSelected: state.tasks.addOrEdit.groupToRemoveFromSelected,
		contactsSelectedForGroup: state.tasks.addOrEdit.contactsSelectedForGroup,
		automationTypeSelected: state.tasks.addOrEdit.automationTypeSelected,
		// delay: state.tasks.addOrEdit.delay,
		// whenToTrigger: state.tasks.addOrEdit.whenToTrigger,
	}),
	(dispatch) =>
		bindActionCreators(
			{
				selectGroup,
				selectGroupToAddTo,
				selectGroupToRemoveFrom,
				selectContactsForGroup,
				toggleGroupDialog,
			},
			dispatch,
		),
)(
	withStyles((theme) => ({
		paper: {
			[theme.breakpoints.down('sm')]: {
				padding: 20,
			},
		},
	}))(
		({
			selectedAction,
			groupOptions,
			contactOptions,
			groupSelected,
			groupToAddToSelected,
			groupToRemoveFromSelected,
			contactsSelectedForGroup,
			automationTypeSelected,
			selectGroup,
			selectGroupToAddTo,
			selectGroupToRemoveFrom,
			selectContactsForGroup,
			classes,
			toggleGroupDialog,
		}) => {
			const customStyles = {
				control: (provided) => ({
					...provided,
					borderColor: 'rgba(0, 0, 0, 0.23)',
					borderRadius: '28px',
					padding: '9px 0',
				}),
				menu: (provided) => ({
					...provided,
					zIndex: 2,
				}),
			}

			const funcObj = {
				selectContactsForGroup: selectContactsForGroup,
				selectGroupToRemoveFrom: selectGroupToRemoveFrom,
				selectGroupToAddTo: selectGroupToAddTo,
				selectGroup: selectGroup,
			}

			const [dropdownClicked, changeDropdownClicked] = useState(null)

			return (
				<>
					<div className={classes.paper}>
						<Grid container spacing={16}>
							{automationTypeSelected === 'stage' ? null : (
								<Grid item xs={12}>
									<Typography variant="h5" gutterBottom>
										{`Select the contacts that you want to ${
											selectedAction === 'groupMove'
												? 'move between groups'
												: selectedAction === 'groupAdd'
												? 'add to a group'
												: 'remove from a group'
										}`}
									</Typography>
									{/* <FormHelperText>Selected contacts</FormHelperText> */}
									<ReactSelect
										styles={customStyles}
										value={contactsSelectedForGroup}
										onChange={(newValue) => {
											if (newValue.value === 'new') {
												changeDropdownClicked('selectContactsForGroup')
												toggleGroupDialog()
											} else {
												selectContactsForGroup(newValue)
											}
										}}
										closeMenuOnSelect={false}
										isMulti
										options={contactOptions}
										placeholder="Selected contacts"
									/>
								</Grid>
							)}
							{selectedAction === 'groupMove' ? (
								<Grid item xs={12}>
									<Typography variant="h5" gutterBottom>
										Select the group that your contacts will be removed from
									</Typography>
									{/* <FormHelperText>
                  Selected groups contacts will be removed from
                </FormHelperText> */}
									<ReactSelect
										styles={customStyles}
										value={groupToRemoveFromSelected}
										onChange={(newValue) => {
											if (newValue.value === 'new') {
												changeDropdownClicked('selectGroupToRemoveFrom')
												toggleGroupDialog()
											} else {
												selectGroupToRemoveFrom(newValue)
											}
										}}
										closeMenuOnSelect={false}
										// isMulti
										options={[
											{
												groupID: 'new',
												value: 'new',
												label: 'Create new group',
											},
											...groupOptions,
										]}
										placeholder="Selected group to remove from"
									/>
								</Grid>
							) : null}
							{selectedAction === 'groupMove' ? (
								<Grid item xs={12}>
									<Typography variant="h5" gutterBottom>
										Select the group that your contacts will be added to
									</Typography>
									{/* <FormHelperText>
                  Selected groups contacts will be added to
                </FormHelperText> */}
									<ReactSelect
										styles={customStyles}
										value={groupToAddToSelected}
										onChange={(newValue) => {
											if (newValue.value === 'new') {
												changeDropdownClicked('selectGroupToAddTo')
												toggleGroupDialog()
											} else {
												selectGroupToAddTo(newValue)
											}
										}}
										closeMenuOnSelect={false}
										// isMulti
										options={[
											{
												groupID: 'new',
												value: 'new',
												label: 'Create new group',
											},
											...groupOptions,
										]}
										placeholder="Selected group to add to"
									/>
								</Grid>
							) : null}
							{selectedAction !== 'groupMove' ? (
								<Grid item xs={12}>
									<Typography variant="h5" gutterBottom>
										{selectedAction === 'groupAdd'
											? `Select the group that your contacts will be added to`
											: `Select the group that your contacts will be removed from`}
									</Typography>
									{/* <FormHelperText>
                  {selectedAction === 'groupAdd'
                    ? `Selected groups contacts will be added to`
                    : `Selected groups contacts will be removed from`}
                </FormHelperText> */}
									<ReactSelect
										styles={customStyles}
										value={groupSelected}
										onChange={(newValue) => {
											if (newValue.value === 'new') {
												changeDropdownClicked('selectGroup')
												toggleGroupDialog()
											} else {
												selectGroup(newValue)
											}
										}}
										closeMenuOnSelect={false}
										// isMulti
										options={[
											{
												groupID: 'new',
												value: 'new',
												label: 'Create new group',
											},
											...groupOptions,
										]}
										placeholder={`${'Selected group to'} ${
											selectedAction === 'groupAdd'
												? `${language.task.add.helperText.addTo}`
												: `${language.task.add.helperText.removeFrom}`
										}`}
									/>
								</Grid>
							) : null}
						</Grid>
					</div>
					<GroupDialog
						thenFunc={(payload) => {
							if (funcObj?.[dropdownClicked]) {
								funcObj[dropdownClicked]({
									groupID: payload.id,
									value: payload.id,
									label: `${payload.name}`,
									key: `${payload.id}GroupSelectValue`,
								})
							}
							changeDropdownClicked(null)
						}}
					/>
				</>
			)
		},
	),
)
